import { Dispatch, SetStateAction } from "react";
import {
  BaseVideoControls,
  PlayerAction
} from "../../../../../components/app-video/video-models";
import { ProductTag } from "../components/ProductTag/ProductTag.component";
import useLongPress from "../hooks/useLongPress";
import { FileType } from "../models/funUgc.model";
import styles from "./UgcPlayerController.module.scss";
import Image from "next/image";
import NextIcon from "../../../../../../shared-assets/images/funUgc/modal/LeftIcon.png";
import PreviousIcon from "../../../../../../shared-assets/images/funUgc/modal/RightIcon.png";
import useWindowWidth from "../../../../../services/window-width-hook";
import FunLoading from "../components/Loading/funLoading";
import { ImagePlayerAction } from "../modal/funUGCModal.component";

interface UgcPlayerControllerProps extends BaseVideoControls {
  fileType: FileType;
  onNext: () => void;
  onPrevious: () => void;
  setImageState: React.Dispatch<React.SetStateAction<ImagePlayerAction>>;
}

function UgcPlayerController({
  state,
  fileType,
  onNext,
  onPrevious,
  setAction,
  setImageState
}: UgcPlayerControllerProps) {
  const { isLoading } = state;
  const { isMobile } = useWindowWidth();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.clickableArea}>
          {isLoading &&
          (fileType === "Dub" ||
            fileType === "Gallery" ||
            fileType === "Dubsmash" ||
            fileType === "Story") ? (
            <div className={styles.spinnerLoader}>
              <FunLoading size={50} />
            </div>
          ) : (
            <>
              <div
                className={styles.clickableItemPrevious}
                onClick={() => onPrevious()}
              ></div>

              <LongPressButton
                setAction={setAction}
                setImageState={setImageState}
              />

              <div
                className={styles.clickableItemNext}
                onClick={() => onNext()}
              ></div>
            </>
          )}
        </div>

        <div className={styles.productTag}>
          <ProductTag fileType={fileType} />
        </div>
      </div>

      {isMobile && (
        <div className={styles.mobileControllers}>
          <div
            className={styles.previousWrapperMobile}
            onClick={() => onPrevious()}
          >
            <div className={styles.previousMobile}>
              <Image
                src={PreviousIcon}
                alt="قبلی"
                layout="fill"
                priority={true}
              />
            </div>
          </div>

          <div className={styles.nextWrapperMobile} onClick={() => onNext()}>
            <div className={styles.nextMobile}>
              <Image src={NextIcon} alt="بعدی" layout="fill" priority={true} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UgcPlayerController;

interface LongPressButtonProps {
  setAction: Dispatch<SetStateAction<PlayerAction>>;
  setImageState: React.Dispatch<React.SetStateAction<ImagePlayerAction>>;
}

const LongPressButton = ({
  setAction,
  setImageState
}: LongPressButtonProps) => {
  const onLongPress = (e: MouseEvent | TouchEvent) => {
    setAction({
      action: "pause"
    });
    setImageState("Pause");
  };

  const onClick = (e: MouseEvent | TouchEvent) => {
    setAction({
      action: "play"
    });
    setImageState("Play");
  };

  const onLongPressEnd = (e: MouseEvent | TouchEvent) => {
    setAction({
      action: "play"
    });
    setImageState("Play");
  };

  const longPressRef = useLongPress(onLongPress, onLongPressEnd, onClick);

  return (
    <div
      className={styles.clickableItemPlay}
      ref={longPressRef as React.RefObject<HTMLDivElement>}
    ></div>
  );
};
